// Projabze marka OLE2FRAME blob hex (AutoCAD drawing 67 birebir binary).
// Buyuk hex JSON dosyasinda tutulur; ESLint no-octal-escape kurali dev JS
// string uzerinde stack tasiriyordu. JSON ESLint kurallarina girmez.
import brandOle from "./projabzeBrandOle.json";
export const PROJABZE_BRAND_OLE_HEX = brandOle.hex;
